import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import { FaRegCircle, FaCircle } from 'react-icons/fa6';
import { useCallback, useEffect } from "react";
import Helpers from "@/Helpers";

export default function ColorsheetVertical(props) {
   const { sectionData, values, setValue } = props;
   const currentSection = sectionData?.currentSection;

   const getIssueCount = useCallback(function (validationValues) {
      let totalIssueCount = 0;
      const valueMap = new Map();
      const duplicateValues = new Set();
      for (let i = 1; i <= 4; i++) {
         const value = validationValues[currentSection.formId + i];
         if (value === undefined || value <= 0) {
            totalIssueCount++;
         }
         else {
            if (valueMap.has(value)) {
               duplicateValues.add(value);
            } else {
               valueMap.set(value, i);
            }
         }
      }
      for (let i = 1; i <= 4; i++) {
         const value = validationValues[currentSection.formId + i];
         if (value !== undefined && value > 0 && duplicateValues.has(value)) {
            totalIssueCount++;
         }
      }
      return totalIssueCount;
   }, [currentSection?.formId]);

   useEffect(() => {
      sectionData.registerSection( 700);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentSection?.name]);

   const content = Helpers.getSectionContent(currentSection, sectionData?.lang);
   const elements = Helpers.getSectionElements(content);
   const squares = Array.isArray(elements?.items) ? elements.items : [];
   const prompt = elements?.prompt || {};
   const oops = elements?.oops || {};
   const instructionsHtml = Helpers.getSectionHtmlValue(content, "instructions");

   function getSquareHtml(square, index) {
      return Helpers.getColorsheetSquareHtml(content, square, index);
   }

   function onChange(e) {
      const id = parseInt(e.currentTarget.getAttribute("data-id"));
      setValue(id, parseInt(e.currentTarget.getAttribute("data-value")));
   }

   useEffect(() => {
      const nextCount = Number(sectionData?.nextCount || 0);
      const issueCount = nextCount > 0 ? getIssueCount(values || {}) : 0;
      sectionData?.updateIssueCount?.(issueCount);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentSection?.formId, getIssueCount, sectionData?.nextCount, sectionData?.updateIssueCount, values]);

   function options(index, column) {
      const value = values[currentSection.formId + index] ?? "";
      const valuesArray = Object.values(values); // Convert object values to an array
      const numberOfProperties = valuesArray.length;
      const isDuplicate = numberOfProperties > 0 && valuesArray.filter(v => v === value).length > 1;
      const isMissing = value === undefined || !value || value === -1;
      if (!prompt || Object.keys(prompt).length < 4) return null;

      const radioOptions = [
         { val: 4, label: prompt["4"] },
         { val: 3, label: prompt["3"] },
         { val: 2, label: prompt["2"] },
         { val: 1, label: prompt["1"] },
      ];
      const square = squares[index - 1] || {};
      const colorClass = Helpers.resolveColorsheetColorKey(square, index);
      return (
         <div className={`column ${colorClass}`} data-column={column}>
            <div className="text">{parseSanitizedHtml(getSquareHtml(square, index))}</div>
            <div className="optionsColumn">
               {radioOptions.map(opt => (
                  <button
                     key={opt.val}
                     type="button"
                     data-value={opt.val}
                     className={`radioLabel${value === opt.val ? ' selected' : ''}`}
                     onClick={onChange}
                     data-id={index}
                  >
                     {value === opt.val ? (
                        <FaCircle className="actionIcon" />
                     ) : (
                        <FaRegCircle className="actionIcon" />
                     )}
                     <span className="radioText">{opt.label}</span>
                  </button>
               ))}
               {sectionData.showValidations && isMissing && (
                  <span className="validation">{oops["missing"]}</span>
               )}
               {sectionData.showValidations && value > 0 && isDuplicate && (
                  <span className="validation">{oops["repeated"]}</span>
               )}
            </div>
         </div>
      );
   }
   return (
      <div className={`page ColorsheetVertical ${sectionData.lang && sectionData.lang !== "eng" ? "nonEnglishLayout esp" : ""}`}>

         {instructionsHtml &&
            <div className="instructions">{parseSanitizedHtml(instructionsHtml)}</div>}

         <div className="content">
            {options(1, 1)}
            {options(2, 2)}
            {options(3, 3)}
            {options(4, 4)}
         </div>
      </div>
   );
}
